<template>
  <div
    id="b2b-sent-request-form"
    class="b2b-sent-request-form"
  >
    <div>
      <button
        class="app__button"
        @click="toggleForm()"
      >
        Заявка на подключение
      </button>
    </div>
    <app-from
      ref="form"
    />
  </div>
</template>

<script>
import AppFrom from './components/AppForm.vue';

export default {
  name: "app",
  components: {
    AppFrom: AppFrom
  },
  methods: {
    toggleForm(){
      this.$refs.form.toggle();
    }
  }
};
</script>

<style>
.app__button {
  border: none;
  background: rgb(2, 142, 213);
  padding: 12px 42px;
  border-radius: 50px;
  color: #ffffff;
  outline: none;
  cursor: pointer;
}

.app__button:hover {
  background: rgb(55, 134, 204);
}

.app__button:active {
  background: rgb(42, 99, 150);
}

@media only screen and (max-width: 1290px) {
  .app__button {
    display: none;
  }
}
</style>
